import React, { Component } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";

// mdreact
import { MDBDataTableV5 } from "mdbreact";

// react router dom
import { Link } from "react-router-dom";

// sweetalert2t
import Swal from "sweetalert2";
// toast
import { toast } from "react-toastify";

// component
import { BASE_URL, Bublic_URL } from "../component/BASE_URL";
import axios from "axios";
import GetUserToken from "../component/GetUserToken";
import DashboardHeader from "../component/DashboardHeader";

const token = GetUserToken();
const parse = require("html-react-parser");

const withRouter = (WrappedComponent) => (props) => {
  const navigate = useNavigate();
  const params = useParams();
  // etc... other react-router-dom v6 hooks
  return (
    <WrappedComponent
      {...props}
      navigate={navigate}
      params={params}
      // etc...
    />
  );
};

class HistoryWorks extends Component {
  state = {
    show: false,
    date: [],
    loading: true,
    rowDate: {},
  };

  componentDidMount() {
    this.changePlaceHolderValue();
    this.retreveDate();
  }

  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  changePlaceHolderValue = () => {
    document
      .querySelector(".form-control")
      .setAttribute("placeholder", "ابحث هنا");
  };

  retreveDate = () => {
    axios
      .get(`${BASE_URL}articles?type=history_working`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        if (res.status == 200) {
          this.setState({
            loading: false,
          });

          var newData = res.data.data;
          newData.map((dat, index) => {
            dat.index = index + 1;
            dat.image = (
              <div className="tableImage">
                <div className="wrapper">
                  <img
                    src={`${Bublic_URL}${dat.image}`}
                    className=""
                    alt="صورة المقاله"
                  />
                </div>
              </div>
            );

            dat.description = parse(
              `<div className="minmumlines maxpwidth">${dat.description}</div>`
            );

            dat.options = (
              <div className="options">
                <Link
                  to={`edit-historywork/${dat.id}`}
                  className="btn btn-nfc btn-edit ml-1"
                >
                  <i className="fa-solid fa-edit"></i>
                  <span>تعديل</span>
                </Link>
                <button
                  onClick={() => this.deleteAericle(dat)}
                  className="btn btn-nfc btn-delete ml-1"
                >
                  <i className="fa-solid fa-times"></i>
                  <span>حذف</span>
                </button>
              </div>
            );
          });

          this.setState({
            data: newData,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  deleteAericle = (dat) => {
    Swal.fire({
      // title: "info!",
      text: "هل انت متاكد من الحذف",
      icon: "info",
      confirmButtonText: "تأكيد الحذف",
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire("تم المسح", "", "success");
        this.confirmDeleteAericle(dat);
      }
    });
  };

  confirmDeleteAericle = (dat) => {
    this.setState({
      loading: true,
    });
    let oldData = [...this.state.data];

    let newDate = this.state.data.filter((item) => item.id !== dat.id);
    this.setState({
      data: newDate,
      loadintable: false,
    });

    axios
      .delete(`${BASE_URL}articles/${dat.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        // console.log(res.status)
        if (res.status == 200) {
          this.setState({
            loading: false,
          });
          toast.success("تم الحذف بنجاح");
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        toast.error("لم يتم المسح");
        this.setState({
          data: oldData,
        });
        console.log(error.response);
      });
  };

  render() {
    const { loading, rowDate, show } = this.state;
    const datatable = {
      columns: [
        { label: "الترتيب", field: "index" },
        { label: "الصورة", field: "image" },
        { label: "العنوان", field: "title" },
        { label: "الوصف", field: "description" },
        { label: "الاختيارات", field: "options" },
      ],
      rows: this.state.data,
    };
    return (
      <div className="main-content">
        <DashboardHeader />

        <div className="dashboard-content">
          <div className="dasboard-box">
            <div className="dashboard_title">
              <h5>سابقة الاعمال</h5>
              <div className="add-aNew">
                <Link to="add-historywork" className="add-new-lnk">
                  اضافه سابقه اعمال
                </Link>
              </div>
            </div>
            <MDBDataTableV5
              hover
              entriesOptions={[5, 10, 15, 20]}
              entries={10}
              pagesAmount={4}
              data={datatable}
              responsive
              searchTop
              searchBottom={false}
            />
          </div>
          {loading ? (
            <div className="loading">
              <div className="circles">
                <div className="circle1"></div>
                <div className="circle2"></div>
                <div className="circle3"></div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default HistoryWorks;
